<div class="epmax-container flex h-100">
    <div class="flex-center m-5 bg-bg1 flex-1 flex-col">
        <epmax-no-data-found [avatarSize]="140" [label]="record.title | translate" [body]="record.message"></epmax-no-data-found>
        <div class="btn-group-container">
            <epmax-button [bottonType]="'button'" [data-automation-id]="'back-to-default-page'" [label]="'Buttons.BackToMainPage' | translate" (click)="goBack()"></epmax-button>
            <epmax-button [bottonType]="'button'" [data-automation-id]="'send-to-support-team'" [label]="'Buttons.SendEmailToSupport'| translate" (click)="senToSupportTeam()" [style]="'outline'"></epmax-button>
        </div>
       
    </div>
  
</div>
